import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import config from "../utils/config"
import {getConfig} from "../utils"
import orders from "@/views/invoice/orders.vue";
import help from "@/views/invoice/help.vue";
const Layout = () => import("../views/layout/index.vue");
const Download = () => import("../views/download/index.vue");
const Practice = () => import("../views/practice/index.vue");
const Service = () => import("../views/service/index.vue");
const Privacy = () => import("../views/privacy/index.vue");
const Cancellation = () => import("../views/cancellation/index.vue");

// const trilateral = () => ("../views/trilateral/index.vue");
const ChildPrivacy = () => import("../views/childPrivacy/index.vue");
const Shop = () => import("../views/shop/index.vue");
const Reunion = () => import("../views/reunion");
const Price = () => import("../views/price");
const Ticket = () => import("../views/ticket");
const Delivery = () => import("../views/delivery");
const Participate = () => import("../views/participate");
const Invoice = () => import("../views/invoice/index.vue");
const invoiceDetail = () => import("../views/invoice/detail.vue");
const Receipt = () => import("../views/receipt/index.vue");
const Activity = () => import("../views/activity");
const ActivityCommon = () => import("../views/activity-comon");
const Invitee = () => import("../views/invitee");
const App = () => import("../views/app");
const Test = () => import("../views/test/index.vue");
const Platform = () => import("../views/platform/index.vue");
const OnlineQrcode = () => import("../views/onlineQrcode/index.vue");
const orderdetail = () => import("../views/order/orderdetail/index.vue");
const openApplet = () => import("../views/openApplet/index.vue");
const jumpMiniProgram = () => import("../views/jumpMiniProgram/index.vue");
const ProtectInformation= () => import("../views/protectInformation/index.vue");
const ProtectInformationGuide= () => import("../views/protectInformationGuide/index.vue");
const TransferPage = () => import("../views/transferPage/index.vue");
const landPage= () => import("../views/landPage/index.vue");
// 主题专区
const Themezone = () => import("../views/themezone/themezone")
// 攒星兑礼
const pointsActivity = () => import("../views/pointsActivity/index")
//张杰演唱会
const lotteryActivity = () => import("../views/lotteryActivity/index")
// 问卷
const crfActivity = () => import("../views/crfActivity/index")

const Redirect = () => import("../views/redirect/index")
const QRredirect = () => import("../views/QRredirect/index")
const kioskDownload = () => import("../views/kiosk/download/index")
const TrilateralPerInfoList =() => import("../views/trilateralPerInfoList/index")
const PerInfoList =() => import("../views/perInfoList/index")




Vue.use(VueRouter);
getConfig()

const routes = [
  {
    path: "/",
    name: "Layout",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
          title: "首页",
        },
      },
      {
        path: "/trilateralPerInfoList",
        name: "trilateralPerInfoList",
        component: TrilateralPerInfoList,
        meta: {
          title: "第三方共享个人信息清单",
        },
      },
      {
        path: "/perInfoList",
        name: "perInfoList",
        component: PerInfoList,
        meta: {
          title: "个人信息收集清单",
        },
      },
      // {
      //   path: "/trilateral",
      //   name: "trilateral",
      //   component: trilateral,
      //   meta: {
      //     title: "第三方共享个人信息清单",
      //   },
      // },
      {
        path: "/download",
        name: "Download",
        component: Download,
        meta: {
          title: config.env.VUE_APP_BRAND == "COTTI" ? "库迪咖啡" : "茶猫",
        },
      },
      {
        path: "/kiosk/download",
        name: "Download",
        component: kioskDownload,
        meta: {
          title: "",
        },
      },
      {
        path: "/app",
        name: "App",
        component: App,
        meta: {
          title: config.env.VUE_APP_BRAND == "COTTI" ? "库迪咖啡" : "茶猫",
        },
      },
      {
        path: "/practice",
        name: "Practice",
        component: Practice,
        meta: {
          title: "舌尖英雄",
        },
      },
      {
        path: "/service",
        name: "Service",
        component: Service,
        meta: {
          title: "用户使用协议",
        },
      },
      {
        path: "/privacy",
        name: "Privacy",
        component: Privacy,
        meta: {
          title: "用户隐私协议",
        },
      },
      
      {
        path: "/cancellation",
        name: "Cancellation",
        component: Cancellation,
        meta: {
          title: "账号注销",
        },
      },
      {
        path: "/childPrivacy",
        name: "childPrivacy",
        component: ChildPrivacy,
        meta: {
          title: "儿童隐私保护声明",
        },
      },
      {
        path: "/protectInformation",
        name: "protectInformation",
        component: ProtectInformation,
        meta: {
          title: "个人信息保护咨询指引",
        },
      },
      {
        path: "/protectInformationGuide",
        name: "protectInformationGuide",
        component: ProtectInformationGuide,
        meta: {
          title: "个人信息保护咨询指引",
        },
      },
      {
        path: "/shop",
        name: "Shop",
        component: Shop,
        meta: {
          title: "我要开业",
        },
      },
      {
        path: "/reunion",
        name: "Reunion",
        component: Reunion,
        meta: {
          title: "年夜饭",
        },
      },
      {
        path: "/price",
        name: "Price",
        component: Price,
        meta: {
          title: "价格说明",
        },
      },
      {
        path: "/ticket",
        name: "Ticket",
        component: Ticket,
        meta: {
          title: "加载中",
        },
      },
      {
        path: "/transferPage",
        name: "TransferPage",
        component: TransferPage,
        meta: {
          title: ""
        }
      },
      {
        path: "/delivery",
        name: "Delivery",
        component: Delivery,
        meta: {
          title: "舌尖次日达",
        },
      },
      {
        path: "/participate",
        name: "Participate",
        component: Participate,
        meta: {
          title: "",
        },
      },
      {
        path: "/invoice",
        name: "Invoice",
        component: Invoice,
        meta: {
          title: "订单开票",
        },
      },
      {
        path: "/invoice/Detail",
        name: "invoiceDetail",
        component: invoiceDetail,
        meta: {
          title: "发票详情",
        },
      },
      {
        path: "/invoice/orders",
        name: "invoiceDetail",
        component: orders,
        meta: {
          title: "发票相关订单",
        },
      },
      {
        path: "/invoice/help",
        name: "help",
        component: help,
        meta: {
          title: "开票帮助",
        },
      },
      {
        path: "/receipt",
        name: "Receipt",
        component: Receipt,
        meta: {
          title: "开票信息",
        },
      },
      {
        path: "/test",
        name: "Test",
        component: Test,
        meta: {
          title: "测试",
        },
      },
      {
        path: "/newUserActivity",
        name: "Activity",
        component: Activity,
        meta: {
          title: "活动说明",
        },
      },
      {
        path: "/activityCommon",
        name: "ActivityCommon",
        component: ActivityCommon,
        meta: {
          title: "活动说明",
        },
      },
      {
        path: "/Platform",
        name: "Platform",
        component: Platform,
        meta: {
          title: "平台资质",
        },
      },
      {
        path: "/invitee",
        name: "Invitee",
        component: Invitee,
        meta: {
          title: "舌尖英雄",
        },
      },
      {
        path: "/themezone",
        name: 'Themezone',
        component: Themezone,
        meta: {
          title: "优质潜江龙虾，特惠开吃"
        }
      },
      {
        path: "/onlineqrcode",
        name: "OnlineQrcode",
        component: OnlineQrcode,
        meta: {
          title: "社群福利",
        }
      },
      {
        path: "/orderdetail",
        name: "orderdetail",
        component: orderdetail,
        meta: {
          title: "订单详情",
        }
      },
      {
        path: "/openApplet",
        name: "openApplet",
        component: openApplet,
        meta: {
          title: "",
        }
      },
      {
        path: "/jumpMiniProgram",
        name: "jumpMiniProgram",
        component: jumpMiniProgram,
        meta: {
          title: "",
        }
      },
      {
        path: "/pointsActivity",
        name: "pointsActivity",
        component: pointsActivity,
        meta: {
          title: "",
        }
      },
      {
        path: "/lotteryActivity",
        name: "lotteryActivity",
        component: lotteryActivity,
        meta: {
          title: "",
        }
      },
      {
        path: "/redirect",
        name: "Redirect",
        component: Redirect,
        meta: {
          title: "",
        }
      },
      {
        path: "/landPage",
        name: "landPage",
        component: landPage,
        meta: {
          title: "",
        }
      },
      {
        path: "/crfActivity",
        name: "crfActivity",
        component: crfActivity
      },
      {
        path: "/QRredirect",
        name: "QRredirect",
        component: QRredirect,
        meta: {
          title: "",
        }
      },
    ],
  }
];

const router = new VueRouter({
  routes,
});

export default router;
